export default () => {
    const route = window.location.pathname
    const items = localStorage.menuitem
        ? JSON.parse(localStorage.menuitem)
        : []

    const i = items.findIndex(item => item.IMenuLinkTo === route)

    return i < 0 ? null : items[i]
}